export default __webpack_public_path__ + "static/media/micky.d1bf95ad.png";